import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { doSetUserCode, doSetCssUserCss } from '../../redux/reducers';
import { saveBookInLocalStorage } from '../utils'

export const LiveContextTypes = {
  code: PropTypes.string,
  css: PropTypes.string,
  error: PropTypes.string,
  onHtmlChange: PropTypes.func,
  onCssChange: PropTypes.func
};

class HtmlLiveProvider extends Component {
  static childContextTypes = LiveContextTypes;

  static propTypes = {
    code: PropTypes.string,
    css: PropTypes.string,
    codeId: PropTypes.string,
    activeChapterId: PropTypes.number
  };

  onUserCodeChange = code => {
    const { activeChapterId, codeId } = this.props;
    this.props.onUserCodeChange( activeChapterId, codeId, code );
  }

  onCssUserCodeChange = code => {
    const { activeChapterId, codeId } = this.props;
    this.props.onCssUserCodeChange( activeChapterId, codeId, code );
  }

  componentWillReceiveProps(nextProps) {
    const { book } = this.props;
    const newBook = nextProps.book;

    if (!!newBook && book !== newBook ) {
      saveBookInLocalStorage(newBook);
    }
  }

  getChildContext = () => ({
    code: this.props.code || "",
    css: this.props.css || "",
    onHtmlChange: this.onUserCodeChange,
    onCssChange: this.onCssUserCodeChange
  });

  render() {
    const { children } = this.props;
    return <div>{children}</div>;
  }
}

const mapStateToProps = state => ({
  book: state.book,
  activeChapterId: state.book.activeChapterId
})

const mapDispatchToProps = dispatch => ({
  onUserCodeChange: (activeChapterId, codeId, code) => dispatch(doSetUserCode(activeChapterId, codeId, code)),
  onCssUserCodeChange: (activeChapterId, codeId, code) => dispatch(doSetCssUserCss(activeChapterId, codeId, code))
})

export default connect(mapStateToProps, mapDispatchToProps)(HtmlLiveProvider);



// WEBPACK FOOTER //
// ./src/book/editors/HtmlLiveProvider.js